import React, { useState } from 'react';
import './PathhCard.css';

const PathhCategoryCard = ({ pathh, categoryId, onDelete, onEdit }) => {
  const [expanded, setExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editTitle, setEditTitle] = useState(pathh.title);
  const [editText, setEditText] = useState(pathh.pathh_text);

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const handleEditClick = () => {
    setEditTitle(pathh.title);
    setEditText(pathh.pathh_text);
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditTitle(pathh.title);
    setEditText(pathh.pathh_text);
  };

  const handleSaveEdit = () => {
    if (onEdit) {
      onEdit(categoryId, pathh.title, editTitle, editText);
    }
    setIsEditing(false);
  };

  return (
    <>
      {/* Edit Modal */}
      {isEditing && (
        <div className="edit-modal-overlay" onClick={(e) => e.stopPropagation()}>
          <div className="edit-modal">
            <h2>✏️ Edit Pathh</h2>
            <div className="edit-form">
              <label>Title:</label>
              <input
                type="text"
                value={editTitle}
                onChange={(e) => setEditTitle(e.target.value)}
              />
              <label>Pathh Text:</label>
              <textarea
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
                rows={10}
              />
              <div className="edit-modal-buttons">
                <button className="save-button" onClick={handleSaveEdit}>💾 Save</button>
                <button className="cancel-button" onClick={handleCancelEdit}>❌ Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="pathh-card">
        <div className="pathh-header">
          <h5 className="pathh-title">{pathh.title}</h5>
          <div className="pathh-actions">
            <button
              className="edit-pathh-btn"
              onClick={handleEditClick}
              title="Edit this pathh"
            >
              ✏️
            </button>
            <button
              className="delete-pathh-btn"
              onClick={() => onDelete(categoryId, pathh.title)}
              title="Delete this pathh"
            >
              🗑️
            </button>
          </div>
        </div>

        <div className="pathh-content">
          <div className="pathh-text">
            {expanded ? (
              <pre className="pathh-text-full">{pathh.pathh_text}</pre>
            ) : (
              <p className="pathh-text-preview">
                {truncateText(pathh.pathh_text, 150)}
              </p>
            )}
          </div>

          {pathh.pathh_text && pathh.pathh_text.length > 150 && (
            <button
              className="expand-btn"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? '📖 Show Less' : '📜 Read Full'}
            </button>
          )}
        </div>

        <div className="pathh-footer">
          <div className="pathh-meta">
            <span className="pathh-date">
              📅 {formatDate(pathh.created_at)}
            </span>
            <span className="pathh-length">
              📝 {pathh.pathh_text?.length || 0} chars
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PathhCategoryCard;
